import { useState } from 'react';

import { useAuth } from '@pflegia/ui/contexts/auth.context';
import useMountEffect from '@pflegia/ui/hooks/use-mount-effect';

import { useRouterHelper } from './use-router-helper';

export const useAnonymized = () => {
  const { isTransparentPath, isPreview, isSeoLandingPage } = useRouterHelper();
  const authenticated = useAuth();

  const shouldAnonymizeByRoute =
    !isTransparentPath && !isPreview && !isSeoLandingPage && (process.env.NEXT_PUBLIC_ANONYMIZE_DETAILS ?? 'true') === 'true';

  const [isMounted, setIsMounted] = useState(false);

  useMountEffect(() => setIsMounted(true));

  // Keep SSR and first client render aligned, then apply auth-aware state after hydration.
  if (!isMounted) return shouldAnonymizeByRoute;

  return shouldAnonymizeByRoute && !authenticated;
};
